import React, { useEffect, useState } from "react";
import t, { AsHtml } from "../../../utils/translate";

import styles from "./styles.module.scss";
import SiteWrapper from "../../SiteWrapper";
import Column from "../../Column";
import SequenceProgressBar from "../../SequenceProgressBar";

/**
 *
 * @param {object} props
 * @param {import("react").ReactNode} props.children
 * @returns
 */
export default function SequenceLoadingInterstitial(props) {
  const { children } = props;

  const [loading, setLoading] = useState(true);
  const delay = 500;

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, delay);
  }, [delay]);

  return (
    <>
      {loading ? (
        <SiteWrapper size="small">
          <Column className={styles.content}>
            <SequenceProgressBar hideBack={true} />
            <h1 className={styles.heading}>
              {t("SEQUENCE_LOADING_INTERSTITIAL_HEADER")}
            </h1>
            <p className={styles.text}>
              <AsHtml value={t("SEQUENCE_LOADING_INTERSTITIAL_TEXT")} />
            </p>
            <div className={styles.loadingCtn}>
              <div className={styles.loading}></div>
            </div>
          </Column>
        </SiteWrapper>
      ) : (
        children
      )}
    </>
  );
}
